import { typeScale, fontWeight } from './typography';

/** Shared mobile-first, Apple-inspired homepage surface styles */
export const homeUi = {
  sectionPy: { xs: 5, sm: 6, md: 9 },
  containerPx: { xs: 2, sm: 3 },
  cardRadius: 3,
  innerRadius: 2.5,
  cardBorder: '1px solid rgba(0, 0, 0, 0.06)',
  cardBg: '#ffffff',
  pageBg: '#fbfbfd',
  cardShadow: '0 1px 2px rgba(0, 0, 0, 0.04), 0 8px 24px rgba(0, 0, 0, 0.04)',
  cardShadowHover: '0 4px 8px rgba(0, 0, 0, 0.04), 0 16px 40px rgba(0, 0, 0, 0.08)',
  touchTarget: { minHeight: 48 },
  title: {
    fontWeight: fontWeight.bold,
    letterSpacing: '-0.028em',
    lineHeight: 1.15,
  },
  /** Section & page headings — smaller on mobile to avoid dominating the viewport */
  sectionTitle: typeScale.headingMd,
  sectionHeaderMb: { xs: 2.5, md: 4.5 } as const,
  body: typeScale.body,
  bodySm: typeScale.bodySm,
  bodyLg: typeScale.bodyLg,
  badge: typeScale.badge,
  caption: typeScale.caption,
  chip: typeScale.chip,
  headingSm: typeScale.headingSm,
  headingLg: typeScale.headingLg,
  display: typeScale.display,
  stat: typeScale.stat,
  heroStat: typeScale.heroStat,
  price: typeScale.price,
  cardTitle: typeScale.cardTitle,
  nav: typeScale.nav,
  navLink: typeScale.navLink,
  drawerItem: typeScale.drawerItem,
  drawerSubItem: typeScale.drawerSubItem,
  footerTitle: typeScale.footerTitle,
  homeHeroTitle: typeScale.homeHeroTitle,
  homeHeroBody: typeScale.homeHeroBody,
  ctaButton: typeScale.ctaButton,
  prose: typeScale.prose,
  glass: {
    bgcolor: 'rgba(255, 255, 255, 0.72)',
    backdropFilter: 'saturate(180%) blur(20px)',
    WebkitBackdropFilter: 'saturate(180%) blur(20px)',
    border: '1px solid rgba(255, 255, 255, 0.5)',
  },
};
